import { MeterElectricOutlineIcon } from './MeterElectricOutlineIcon';

/**
 * author: Google
 * id 463AE2E1-1BA3-444B-9182-D252575B2C8E
 * name meter-electric-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/meter-electric-outline.svg
 * tags
 * - Home Automation 
 */
export const PowerMeterOutlineIcon = MeterElectricOutlineIcon;
export default PowerMeterOutlineIcon